export class ConfirmModalPopupModel {
  modalHeader: string;
  modalSubHeader: string;
  modalMessage: string;
  confirmButtonMessage: string;
  cancelButtonMessage: string;
  confirmButtonAccessibilityText: string;
  cancelButtonAccessibilityText: string;
  showConfirmButton: boolean;
  showCancelButton: boolean;

  constructor() {
  this.modalHeader = undefined;
  this.modalSubHeader = undefined;
  this.modalMessage = undefined;
  this.confirmButtonMessage = 'OK';
  this.cancelButtonMessage = 'Cancel';
  this.confirmButtonAccessibilityText = 'OK';
  this.cancelButtonAccessibilityText = 'Cancel';
  this.showConfirmButton = true;
  this.showCancelButton = true;
  }
}
